import { render, staticRenderFns } from "./SchemaModel.vue?vue&type=template&id=59b2e6c6&scoped=true"
import script from "./SchemaModel.vue?vue&type=script&lang=js"
export * from "./SchemaModel.vue?vue&type=script&lang=js"
import style0 from "./SchemaModel.vue?vue&type=style&index=0&id=59b2e6c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b2e6c6",
  null
  
)

export default component.exports